module.exports = "https://static.energy5.com/_next/static/images/effortlessMobile-e4444aa212c16a771139c0d94934c764.png";